import {Paper as MantinePaper} from '@mantine/core';

/**
 * Surface container — design-layer pass-through over Mantine `Paper`.
 * @registry Pass-through Mantine Paper; import this instead of @mantine/core outside src/design.
 */
export const Paper = MantinePaper;
